package horcrux.frontend.common.views.collections.importdocuments

import horcrux.common.api.dtos.types.CollectionMetadata
import horcrux.common.api.dtos.types.CollectionName
import horcrux.frontend.common.views.collections.CollectionMetadataByID
import horcrux.frontend.common.views.collections.ImportButtonLabel
import horcrux.frontend.common.views.collections.collectiondialogs.isInvalidOrNotUnique
import horcrux.frontend.common.GlobalAppState
import horcrux.frontend.common.State
import horcrux.frontend.common.views.collections.collectiondialogs.CollectionDetailsState
import horcrux.frontend.common.views.collections.collectiondialogs.CollectionMediaType
import horcrux.frontend.common.views.collections.collectiondialogs.CollectionMediaTypeSelector
import horcrux.frontend.common.views.collections.navigator.PrivateCollectionSelector
import horcrux.frontend.common.views.components.containers.VStack
import mui.system.sx
import react.FC
import react.Props
import web.cssom.pt

external interface CollectionDetailsInputProps : Props {
    var importButtonLabelState: State<ImportButtonLabel>
    var currentCollectionMetadataMaybeState: State<CollectionMetadata?>
    var collectionNameMaybeState: State<CollectionName?>
    var collectionMetadataByID: CollectionMetadataByID
    var collectionMediaTypeState: State<CollectionMediaType>
    var collectionDetailsState: CollectionDetailsState
    var globalAppState: GlobalAppState
}

val CollectionDetailsInput = FC<CollectionDetailsInputProps> { props ->
    when (props.importButtonLabelState.get()) {
        ImportButtonLabel.CREATE_COLLECTION_AND_IMPORT -> EditCollectionDetailsDialog {
            this.collectionDetailsState = props.collectionDetailsState
            this.globalAppState = props.globalAppState
        }

        ImportButtonLabel.IMPORT -> PrivateCollectionSelector {
            this.globalAppState = props.globalAppState
            this.sx {
                this.marginTop = 10.pt
            }
        }
    }
}
